// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".report-modal{padding:2rem;display:flex;flex-direction:column;align-items:center;width:480px;font-size:1.1rem}.report-modal h3{font-size:1.4rem}.report-modal input,.report-modal textarea{color:#1E2B4E;padding:8px}.report-modal label{font-size:1rem;font-weight:600;color:#444}\n", ""]);
// Exports
module.exports = exports;
